import * as React from 'react';

interface Props {
  className: string;
}

const Checkmark: React.FC<Props> = ({ className }) => {
  return (
    <svg
      width="17"
      height="13"
      viewBox="0 0 17 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.20711 5.7929C1.81658 5.40238 1.18342 5.40238 0.792893 5.7929C0.402369 6.18343 0.402369 6.81659 0.792893 7.20712L5.79289 12.2071C6.19802 12.6122 6.86002 12.5948 7.24329 12.169L16.2433 2.16897C16.6128 1.75846 16.5795 1.12617 16.169 0.756714C15.7585 0.387255 15.1262 0.420534 14.7567 0.831044L6.46181 10.0476L2.20711 5.7929Z"
      />
    </svg>
  );
};

export default Checkmark;
